var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWechat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5992 20.1501C10.6839 21.3067 10.3998 19.5008 10.3998 19.5008L7.99943 13.4334C7.07581 10.5502 8.79879 12.1334 8.79879 12.1334C8.79879 12.1334 10.2772 13.3449 11.3992 14.0831C12.5206 14.8213 13.7989 14.2998 13.7989 14.2998L29.4916 6.45392C26.5964 2.55162 21.8137 0 16.3991 0C7.56253 0 0.399902 6.79043 0.399902 15.1673C0.399902 19.9857 2.77167 24.2741 6.46597 27.0536L5.79974 31.202C5.79974 31.202 5.47496 32.4131 6.60054 31.8513C7.36753 31.4683 9.32285 30.0959 10.4868 29.2606C12.3166 29.9513 14.3102 30.3349 16.4 30.3349C25.2358 30.3349 32.3999 23.5444 32.3999 15.1674C32.3999 12.741 31.7962 10.4496 30.7269 8.41562C25.7271 11.6741 14.0979 19.2466 12.5992 20.1501Z",
    fill: "#27CA28"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechat);
export default __webpack_public_path__ + "static/media/wechat.0eaca927.svg";
export { ForwardRef as ReactComponent };